import { StorageOfferResource } from 'app/storage-offer/storage-offer.resource';
import { ErrorHandler } from 'app/_services/error-handler.factory';
import * as angular from 'angular';
import { Decimal } from 'decimal.js';

class PlaceStorageOfferBidComponentCtrl implements ng.IController {
    public offer: StorageOfferDto;
    public onSuccessfullyPlacedBid: Function;

    public offerBid: StorageOfferBidDto;
    public submitPending: boolean = false;
    private formDisabled: boolean = false;
    public placeBidForm;
    public minQuantitiesForDisabledForm: string[] = [];
    public maxQuantitiesForDisabledForm: string[] = [];
    public priceAmountsForDisabledForm: string[] = [];

    constructor(
        private readonly $filter: ng.IFilterService,
        private lngOfferResource: StorageOfferResource,
        private errorHandler: ErrorHandler,
        private $anchorScroll: ng.IAnchorScrollService
    ) {}

    $onInit(): void {
        this.initBidValues();
    }

    public createProductBid(productId: number): StorageProductBidDto {
        var price = { value: '', floatingPointNumber: true };
        var maxQuantityValue = 1;

        this.offer.products.forEach((product, index) => {
            if (
                product.id === productId &&
                product.reservePrice &&
                this.offer.allocationMethod === 'UNIFORM_PRICE' // 'Ascending Clock'
            ) {
                price = {
                    value: product.reservePrice.value.value.toString(),
                    floatingPointNumber:
                        product.reservePrice.value.floatingPointNumber
                };
            }
            if (product.id === productId) {
                maxQuantityValue = product.availableQuantity.value;
            }
        });

        return (<StorageProductBidDto>{
            storageProductId: productId,
            minQuantityValue: 1,
            maxQuantityValue: maxQuantityValue,
            priceAmount: price,
            storageContractType: null
        }) as StorageProductBidDto;
    }

    public modifyBid() {
        this.formDisabled = false;
    }

    public placeBid(form: ng.IFormController): boolean {
        if (!form.$valid) {
            return false;
        }

        if (!this.formDisabled) {
            this.offerBid.productBids.forEach((offerBid, index) => {
                const product = this.offer.products.find(
                    (product) => product.id === offerBid.storageProductId
                );
                if (
                    this.offer.allocationMethod === 'PAY_AS_BID' &&
                    product &&
                    product.availableQuantity.value > 1
                ) {
                } else {
                    offerBid.minQuantityValue = offerBid.maxQuantityValue || 1;
                }
                offerBid.maxQuantityValue = offerBid.maxQuantityValue || 1;
                offerBid.priceAmount = offerBid.priceAmount || {
                    value: '0',
                    floatingPointNumber: true
                };
                this.setDisabledValueForMinQuantity(index);
                this.setDisabledValueForMaxQuantity(index);
                this.setDisabledValueForPriceAmount(index);
            });
            this.formDisabled = true;
            this.goToPlaceBidSection();
            return false;
        }

        this.submitPending = true;

        this.lngOfferResource
            .placeBid(
                { id: this.offer.id },
                {
                    ...this.offerBid,
                    productBids: this.offerBid.productBids.map((bid) => {
                        const product = this.offer.products.find(
                            (product) => product.id === bid.storageProductId
                        );
                        return {
                            ...bid,
                            minQuantityValue:
                                this.offer.allocationMethod === 'PAY_AS_BID' &&
                                product &&
                                product.availableQuantity.value > 1
                                    ? bid.minQuantityValue
                                    : this.offer.allocationMethod ===
                                        'PAY_AS_BID'
                                      ? 0
                                      : bid.maxQuantityValue
                        };
                    })
                },
                (res: StorageOfferBidDto) => {
                    this.initBidValues();
                    this.placeBidForm.$setUntouched();
                    this.placeBidForm.$setPristine();
                    this.onSuccessfullyPlacedBid();
                },
                (err: any) => {
                    this.errorHandler(err);
                }
            )
            .$promise.finally(() => {
                this.submitPending = false;
                this.formDisabled = false;
            });

        return true;
    }

    public goToPlaceBidSection(): void {
        this.$anchorScroll('place-a-bid');
    }

    private initBidValues() {
        this.offerBid = { productBids: [] } as StorageOfferBidDto;
        this.offer.products.forEach((product) =>
            this.offerBid.productBids.push(this.createProductBid(product.id))
        );
        this.offerBid.productBids.forEach((bid) =>
            this.setValuesForDisabledForm(bid)
        );
    }

    private setValuesForDisabledForm(bid) {
        this.minQuantitiesForDisabledForm.push(
            this.$filter('number')(bid.maxQuantityValue)
        );
        this.maxQuantitiesForDisabledForm.push(
            this.$filter('number')(bid.maxQuantityValue)
        );
        this.priceAmountsForDisabledForm.push(
            this.$filter('number')(
                '' + bid.priceAmount.value,
                this.getDecimalPlaces(bid.priceAmount.value)
            )
        );
    }

    public setDisabledValueForMinQuantity(i: number) {
        const bid = this.offerBid.productBids[i];
        const product = this.offer.products.find(
            (product) => product.id === bid.storageProductId
        );
        if (
            this.offer.allocationMethod === 'PAY_AS_BID' &&
            product &&
            product.availableQuantity.value > 1
        ) {
            const minQuantityValue =
                this.offerBid.productBids[i].minQuantityValue;
            this.minQuantitiesForDisabledForm[i] =
                this.$filter('number')(minQuantityValue);
        } else {
            this.offerBid.productBids[i].minQuantityValue =
                this.offerBid.productBids[i].maxQuantityValue;
            const minQuantityValue =
                this.offerBid.productBids[i].maxQuantityValue;
            this.minQuantitiesForDisabledForm[i] =
                this.$filter('number')(minQuantityValue);
        }
    }

    public setDisabledValueForMaxQuantity(i: number) {
        const bid = this.offerBid.productBids[i];
        const product = this.offer.products.find(
            (product) => product.id === bid.storageProductId
        );
        if (
            this.offer.allocationMethod === 'PAY_AS_BID' &&
            product &&
            product.availableQuantity.value > 1
        ) {
        } else {
            this.offerBid.productBids[i].minQuantityValue =
                this.offerBid.productBids[i].maxQuantityValue;
        }

        const maxQuantityValue = this.offerBid.productBids[i].maxQuantityValue;
        this.maxQuantitiesForDisabledForm[i] =
            this.$filter('number')(maxQuantityValue);
    }

    public setDisabledValueForPriceAmount(i: number) {
        const priceAmount = this.offerBid.productBids[i].priceAmount.value;
        this.priceAmountsForDisabledForm[i] = this.$filter('number')(
            '' + priceAmount,
            this.getDecimalPlaces(priceAmount)
        );
    }

    public getDecimalPlaces(value: Decimal | string): number {
        if (value === '') return;
        if (value instanceof Decimal) {
            return value.decimalPlaces();
        } else {
            return new Decimal(value).decimalPlaces();
        }
    }
}

angular.module('app').component('pkpPlaceLngOfferBid', {
    controller: PlaceStorageOfferBidComponentCtrl,
    template: require('app/lng-offer-bid/place-lng-offer-bid.component.html'),
    bindings: {
        offer: '<',
        onSuccessfullyPlacedBid: '&'
    }
});
